export default __webpack_public_path__ + "static/voronej-ef6eae22a1f475431e9884867b52a75d.jpg";